(function () {
  'use strict';

  function formatMoney(cents) {
    var formatted = window.Shopify && typeof window.Shopify.formatMoney === 'function'
      ? window.Shopify.formatMoney(cents)
      : '$' + (cents / 100).toFixed(2);
    // Match the page's money_without_trailing_zeros price display: drop a
    // whole-dollar amount's ".00" (or ",00") wherever it lands in the string.
    if (cents % 100 === 0) {
      formatted = formatted.replace(/([.,])00(?=\D*$)/, '');
    }
    return formatted;
  }

  function getGalleryViewer(root) {
    return root.querySelector('media-gallery slider-component[id^="GalleryViewer"]:not([id$="-duplicate"])');
  }

  function getVisibleGallerySlides(viewer) {
    return Array.from(viewer.querySelectorAll('.product__media-item')).filter(function (slide) {
      if (slide.classList.contains('hidden')) return false;
      return window.getComputedStyle(slide).display !== 'none';
    });
  }

  // SCS-NEW-PDP-2 wires its arrows through `goToSlide`, which wraps with a
  // modulo and never renders a disabled state, so neither do these.
  function updateGalleryArrowState(viewer) {
    var prev = viewer.querySelector('button[name="previous"]');
    var next = viewer.querySelector('button[name="next"]');
    if (!prev || !next) return;

    var enabled = getVisibleGallerySlides(viewer).length > 1;
    prev.toggleAttribute('disabled', !enabled);
    next.toggleAttribute('disabled', !enabled);
  }

  // Feeds .SCS-PETSUITE-DOG__gallery-main the active image's natural ratio, the
  // way ProductGallery.jsx feeds --scs-gallery-ratio from applyMediaRatio().
  function readGalleryRatio(viewer) {
    var frame = viewer.closest('.SCS-PETSUITE-DOG__gallery-main') || viewer;
    var active =
      viewer.querySelector('.product__media-item.is-active') ||
      viewer.querySelector('.product__media-item');
    var img = active && active.querySelector('.product__modal-opener--image img, .product__media img');
    if (!img) return;

    var w = img.naturalWidth;
    var h = img.naturalHeight;
    if (!(w > 0) || !(h > 0)) {
      img.addEventListener(
        'load',
        function () {
          readGalleryRatio(viewer);
        },
        { once: true }
      );
      return;
    }

    frame.style.setProperty('--psd-gallery-ratio', w + ' / ' + h);
    frame.style.setProperty('--psd-gallery-w', String(w));
    frame.style.setProperty('--psd-gallery-h', String(h));
  }

  function initGalleryNavigation(root) {
    var gallery = root.querySelector('media-gallery:not([id$="-duplicate"])');
    var viewer = getGalleryViewer(root);
    if (!gallery || !viewer || viewer.dataset.petsuiteNavBound === 'true') return;
    viewer.dataset.petsuiteNavBound = 'true';

    viewer.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest('button[name="previous"], button[name="next"]');
        if (!btn || !viewer.contains(btn)) return;

        var slides = getVisibleGallerySlides(viewer);
        if (slides.length < 2) return;

        var idx = slides.findIndex(function (slide) {
          return slide.classList.contains('is-active');
        });
        if (idx < 0) idx = 0;

        var delta = btn.name === 'next' ? 1 : -1;
        var nextIdx = (idx + delta + slides.length) % slides.length;

        e.preventDefault();
        e.stopPropagation();
        gallery.setActiveMedia(slides[nextIdx].dataset.mediaId, false);
        updateGalleryArrowState(viewer);
        readGalleryRatio(viewer);
      },
      true
    );

    viewer.addEventListener('slideChanged', function () {
      updateGalleryArrowState(viewer);
      readGalleryRatio(viewer);
    });

    updateGalleryArrowState(viewer);
    readGalleryRatio(viewer);
  }

  function initGalleryArrows(root) {
    initGalleryNavigation(root);
  }

  var photoswipeLoadPromise = null;

  function loadPhotoSwipeAssets(root) {
    if (typeof PhotoSwipe !== 'undefined') {
      return Promise.resolve();
    }
    if (photoswipeLoadPromise) {
      return photoswipeLoadPromise;
    }

    var jsUrl = root.dataset.photoswipeJs;
    var cssUrl = root.dataset.photoswipeCss;
    if (!jsUrl) {
      return Promise.reject(new Error('PhotoSwipe URL missing'));
    }

    photoswipeLoadPromise = new Promise(function (resolve, reject) {
      if (cssUrl && !document.querySelector('link[data-petsuite-photoswipe-css]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = cssUrl;
        link.setAttribute('data-petsuite-photoswipe-css', 'true');
        document.head.appendChild(link);
      }

      var script = document.createElement('script');
      script.src = jsUrl;
      script.async = true;
      script.onload = function () {
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return photoswipeLoadPromise;
  }

  function upgradeImageUrl(url, width) {
    if (!url) return url;
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.toString();
    } catch (err) {
      return url;
    }
  }

  function getImageDimensions(img) {
    var width = img.naturalWidth || parseInt(img.getAttribute('width'), 10) || 0;
    var height = img.naturalHeight || parseInt(img.getAttribute('height'), 10) || 0;

    if (width < 2 || height < 2) {
      var ratio = parseFloat(img.getAttribute('data-aspect-ratio') || '');
      width = 2000;
      height = ratio > 0 ? Math.round(width / ratio) : 2000;
    }

    return { width: width, height: height };
  }

  function isSlideVisible(slide) {
    if (!slide || slide.classList.contains('hidden')) return false;
    var style = window.getComputedStyle(slide);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function collectLightboxItems(root) {
    var items = [];
    var mediaWrapper = root.querySelector('.product__media-wrapper:not(.small-hide)');
    if (!mediaWrapper) return items;

    mediaWrapper.querySelectorAll('.product__media-list .product__media-item').forEach(function (slide) {
      if (!isSlideVisible(slide)) return;
      var opener = slide.querySelector('[data-petsuite-lightbox], modal-opener.product__modal-opener--image');
      if (!opener) return;
      var img = opener.querySelector('img');
      if (!img) return;

      var dims = getImageDimensions(img);
      var src = upgradeImageUrl(img.currentSrc || img.src, 2000);

      items.push({
        src: src,
        width: dims.width,
        height: dims.height,
        alt: img.alt || '',
        element: slide,
      });
    });

    return items;
  }

  function getActiveLightboxIndex(items) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].element.classList.contains('is-active')) return i;
    }
    return 0;
  }

  function openPhotoSwipe(root) {
    loadPhotoSwipeAssets(root)
      .then(function () {
        if (typeof PhotoSwipe === 'undefined') return;
        var items = collectLightboxItems(root);
        if (!items.length) return;

        var dataSource = items.map(function (item) {
          return {
            src: item.src,
            width: item.width,
            height: item.height,
            alt: item.alt,
          };
        });

        // Same option set as SCS-NEW-PDP-2's PHOTOSWIPE_OPTIONS. Everything else
        // (arrow markup, icons, placement, looping) is stock PhotoSwipe chrome,
        // exactly as the reference gets it from photoswipe/dist/photoswipe.css.
        var pswp = new PhotoSwipe({
          dataSource: dataSource,
          index: getActiveLightboxIndex(items),
          pinchToClose: true,
          closeOnVerticalDrag: true,
          escKey: true,
          clickToCloseNonZoomable: true,
        });

        pswp.init();
      })
      .catch(function (err) {
        console.error('[PetSuite Dog] PhotoSwipe load failed', err);
      });
  }

  function initPhotoSwipeLightbox(root) {
    var galleryStage = root.querySelector('.SCS-PETSUITE-DOG__gallery-stage');
    if (!galleryStage || galleryStage.dataset.petsuiteLightboxBound === 'true') return;
    galleryStage.dataset.petsuiteLightboxBound = 'true';

    galleryStage.addEventListener(
      'click',
      function (e) {
        if (e.target.closest('button[name="previous"], button[name="next"], .slider-counter__link, .thumbnail, .slider-button')) {
          return;
        }

        var opener = e.target.closest('[data-petsuite-lightbox], .product__modal-opener--image');
        if (!opener || !root.contains(opener)) return;

        var img = e.target.closest('img');
        if (!img || !opener.contains(img)) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        openPhotoSwipe(root);
      },
      true
    );
  }

  function scrollFeaturesTrack(track, direction) {
    if (!track) return;
    var step = track.clientWidth * 0.7;
    track.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  function initFeatureRow(root) {
    var row = root.querySelector('[data-petsuite-feature-row]');
    if (!row) return;

    var track = row.querySelector('[data-petsuite-feature-track]');
    var prev = row.querySelector('[data-petsuite-feature-prev]');
    var next = row.querySelector('[data-petsuite-feature-next]');
    if (!track) return;

    if (prev) {
      prev.addEventListener('click', function () {
        scrollFeaturesTrack(track, -1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        scrollFeaturesTrack(track, 1);
      });
    }
  }

  function scrollActiveThumbIntoView(track) {
    if (!track) return;
    var active = track.querySelector('.thumbnail[aria-current="true"]');
    var item = active ? active.closest('.thumbnail-list__item') : null;
    if (!item) return;
    var left = Math.max(0, item.offsetLeft - track.offsetLeft);
    if (Math.abs(track.scrollLeft - left) < 4) return;
    track.scrollTo({ left: left, behavior: 'smooth' });
  }

  function initThumbnailFeatures(root) {
    var features = root.querySelector('.SCS-PETSUITE-DOG__gallery-features:not(.SCS-PETSUITE-DOG__gallery-features--icons)');
    if (!features || features.dataset.petsuiteFeaturesBound === 'true') return;
    features.dataset.petsuiteFeaturesBound = 'true';

    var track = features.querySelector('.SCS-PETSUITE-DOG__gallery-features-track');
    if (!track) return;

    track.style.scrollSnapType = 'none';
    track.style.scrollPadding = '0px';

    features.querySelectorAll('[data-petsuite-thumb-prev], [data-petsuite-thumb-next]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        scrollFeaturesTrack(track, btn.hasAttribute('data-petsuite-thumb-next') ? 1 : -1);
      });
    });

    var viewer = getGalleryViewer(root);
    if (viewer) {
      viewer.addEventListener('slideChanged', function () {
        scrollActiveThumbIntoView(track);
      });
    }
  }

  // slide-in-reviews.liquid handles `_product_review` clicks globally and
  // listens for `reviewsClickedEvent` (same contract as ProductHeader.jsx).

  // The reviews sheet (#sheet) is shared with ~18 other templates, so the
  // PetSuite design in assets/scs-petsuite-dog-reviews.css is gated behind a
  // class that only this page adds.
  function markReviewsSheet() {
    ['sheet', 'overlay'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.classList.add('scs-reviews--petsuite');
    });
  }

  function configureStampedWidget(widget) {
    if (!widget) return;

    widget.setAttribute('data-take', '6');
    widget.setAttribute('data-page-size', '6');

    if (widget.dataset.scsTakeConfigured === 'true') return;
    widget.dataset.scsTakeConfigured = 'true';

    if (window.StampedFn && typeof window.StampedFn.reloadUGC === 'function') {
      window.StampedFn.reloadUGC();
    }
  }

  function syncReviewsPagination(scope) {
    if (!scope) return;

    scope.querySelectorAll('.stamped-main-widget').forEach(function (widget) {
      configureStampedWidget(widget);

      var reviewsList = widget.querySelector('.stamped-reviews');
      var pagination = widget.querySelector('.stamped-pagination, ul.stamped-reviews-ul');
      if (!pagination) return;

      if (reviewsList && reviewsList.contains(pagination)) {
        reviewsList.insertAdjacentElement('afterend', pagination);
      } else if (reviewsList && pagination.previousElementSibling !== reviewsList) {
        reviewsList.insertAdjacentElement('afterend', pagination);
      }

      pagination.style.width = '100%';
      pagination.style.justifyContent = 'center';
      pagination.style.marginLeft = 'auto';
      pagination.style.marginRight = 'auto';

      var pageLinks = pagination.querySelectorAll('li.page');
      var hasMultiplePages = pageLinks.length > 1;
      var hasNav = !!(
        pagination.querySelector('li.next a:not(.stamped-link-disabled)') ||
        pagination.querySelector('li.previous a:not(.stamped-link-disabled)')
      );

      pagination.dataset.scsHidden = hasMultiplePages || hasNav ? 'false' : 'true';
    });
  }

  function getShareIconUrl() {
    var section = document.querySelector('.SCS-PETSUITE-DOG[data-share-icon]');
    return section ? section.getAttribute('data-share-icon') : '';
  }

  function getShareTriggerHtml() {
    var iconUrl = getShareIconUrl();
    var icon = iconUrl
      ? '<img class="scs-review-share__icon" src="' + iconUrl + '" alt="" width="14" height="14" aria-hidden="true">'
      : '';
    return icon + '<span class="scs-review-share__label">Share</span>';
  }

  function ensureShareTriggerIcon(trigger) {
    if (!trigger || trigger.querySelector('.scs-review-share__icon')) return;
    var iconUrl = getShareIconUrl();
    if (!iconUrl) return;

    var icon = document.createElement('img');
    icon.className = 'scs-review-share__icon';
    icon.src = iconUrl;
    icon.alt = '';
    icon.width = 14;
    icon.height = 14;
    icon.setAttribute('aria-hidden', 'true');

    var label = trigger.querySelector('.scs-review-share__label');
    if (label) {
      trigger.insertBefore(icon, label);
    } else {
      trigger.insertBefore(icon, trigger.firstChild);
    }
  }

  function getShareNetworks(pageUrl) {
    var encoded = encodeURIComponent(pageUrl);
    return [
      { label: 'Facebook', href: 'https://www.facebook.com/sharer/sharer.php?u=' + encoded },
      { label: 'Twitter', href: 'https://twitter.com/intent/tweet?url=' + encoded },
      { label: 'LinkedIn', href: 'https://www.linkedin.com/sharing/share-offsite/?url=' + encoded },
      { label: 'Copy link', href: '#', action: 'copy' }
    ];
  }

  function closeAllShareMenus(except) {
    document.querySelectorAll('[data-scs-share].is-open').forEach(function (share) {
      if (except && share === except) return;
      share.classList.remove('is-open');
      var menu = share.querySelector('.scs-review-share__menu');
      var triggerEl = share.querySelector('.scs-review-share__trigger');
      if (menu) menu.hidden = true;
      if (triggerEl) triggerEl.setAttribute('aria-expanded', 'false');
    });
  }

  function bindCustomShare(shareRoot) {
    if (!shareRoot || shareRoot.dataset.scsShareBound === 'true') return;
    shareRoot.dataset.scsShareBound = 'true';

    var trigger = shareRoot.querySelector('.scs-review-share__trigger');
    var menu = shareRoot.querySelector('.scs-review-share__menu');
    if (!trigger || !menu) return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var willOpen = !shareRoot.classList.contains('is-open');
      closeAllShareMenus(shareRoot);
      shareRoot.classList.toggle('is-open', willOpen);
      if (willOpen) {
        menu.removeAttribute('hidden');
      } else {
        menu.hidden = true;
      }
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });

    menu.querySelectorAll('[data-scs-share-action="copy"]').forEach(function (copyLink) {
      copyLink.addEventListener('click', function (e) {
        e.preventDefault();
        var pageUrl = shareRoot.getAttribute('data-scs-share') || window.location.href;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(pageUrl);
        }
        closeAllShareMenus();
      });
    });
  }

  function replaceStampedShare(shareEl) {
    if (!shareEl || shareEl.dataset.scsShareReady === 'true') return;
    shareEl.dataset.scsShareReady = 'true';

    var wrapper = shareEl.querySelector('.stamped-share-wrapper');
    if (wrapper) wrapper.remove();

    shareEl.querySelectorAll('.stamped-share-links').forEach(function (node) {
      node.remove();
    });

    if (shareEl.querySelector('[data-scs-share]')) {
      var existingShare = shareEl.querySelector('[data-scs-share]');
      ensureShareTriggerIcon(existingShare.querySelector('.scs-review-share__trigger'));
      bindCustomShare(existingShare);
      return;
    }

    var pageUrl = window.location.href.split('#')[0];
    var custom = document.createElement('div');
    custom.className = 'scs-review-share';
    custom.setAttribute('data-scs-share', pageUrl);

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'scs-review-share__trigger stamped-share-icon';
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-haspopup', 'true');
    trigger.innerHTML = getShareTriggerHtml();

    var menu = document.createElement('ul');
    menu.className = 'scs-review-share__menu stamped-share-links';
    menu.hidden = true;

    getShareNetworks(pageUrl).forEach(function (network) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.textContent = network.label;
      if (network.action === 'copy') {
        link.href = '#';
        link.setAttribute('data-scs-share-action', 'copy');
      } else {
        link.href = network.href;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
      }
      item.appendChild(link);
      menu.appendChild(item);
    });

    custom.appendChild(trigger);
    custom.appendChild(menu);
    shareEl.appendChild(custom);
    bindCustomShare(custom);
  }

  function initReviewShare(scope) {
    if (!scope) return;

    scope.querySelectorAll('.stamped-review-share').forEach(replaceStampedShare);
    scope.querySelectorAll('[data-scs-share]').forEach(bindCustomShare);

    if (scope.dataset.scsShareScopeBound === 'true') return;
    scope.dataset.scsShareScopeBound = 'true';

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-scs-share]')) return;
      closeAllShareMenus();
    });

    if (typeof MutationObserver !== 'function') return;

    var shareObserver = new MutationObserver(function () {
      scope.querySelectorAll('.stamped-review-share').forEach(replaceStampedShare);
      scope.querySelectorAll('[data-scs-share]').forEach(bindCustomShare);
    });

    scope.querySelectorAll('.stamped-main-widget').forEach(function (widget) {
      shareObserver.observe(widget, { childList: true, subtree: true });
    });
  }

  function syncReviewImages(scope) {
    if (!scope) return;

    scope.querySelectorAll('.stamped-review-image').forEach(function (block) {
      var img = block.querySelector('img');
      var src = img
        ? (img.getAttribute('src') || img.getAttribute('data-src') || img.currentSrc || '').trim()
        : '';
      var hasImage = !!src && src !== '#' && !/^data:image\/gif/i.test(src);

      block.classList.toggle('is-scs-empty', !hasImage);
      block.hidden = !hasImage;

      if (!hasImage) {
        block.style.display = 'none';
      } else {
        block.style.display = '';
        block.removeAttribute('hidden');
      }
    });
  }

  function initReviewsDecorations(scope) {
    if (!scope) return;
    syncReviewsPagination(scope);
    syncReviewImages(scope);
    initReviewShare(scope);
  }

  function initReviewsSheet() {
    markReviewsSheet();

    var sheet = document.getElementById('sheet');
    if (sheet) {
      initReviewsDecorations(sheet);
      if (typeof MutationObserver === 'function' && sheet.dataset.petsuiteReviewsObserved !== 'true') {
        sheet.dataset.petsuiteReviewsObserved = 'true';
        new MutationObserver(function () {
          initReviewsDecorations(sheet);
        }).observe(sheet, { childList: true, subtree: true });
      }
    }
  }

  function initInlineReviews(root, sectionId) {
    var inline = document.getElementById('petsuite-reviews-' + sectionId);
    if (!inline) return;

    inline.querySelectorAll('.SCS-PETSUITE-DOG__reviews-section').forEach(function (section) {
      section.classList.add('scs-reviews--petsuite');
    });

    initReviewsDecorations(inline);

    if (typeof MutationObserver !== 'function' || inline.dataset.petsuiteReviewsObserved === 'true') return;
    inline.dataset.petsuiteReviewsObserved = 'true';
    new MutationObserver(function () {
      initReviewsDecorations(inline);
    }).observe(inline, { childList: true, subtree: true });
  }

  function initReviewsScroll(root, sectionId) {
    var btn = root.querySelector('[data-petsuite-open-reviews]');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      // Match the standard SCS PDP: open the shared slide-in reviews sheet
      // (slide-in-reviews.liquid listens for this event — see
      // markReviewsSheet() above) instead of scrolling to the inline block.
      document.dispatchEvent(new CustomEvent('reviewsClickedEvent', { bubbles: true }));
    });
  }

  // Same endpoint/section param the slide-in reviews sheet queries
  // (ReviewsService in slide-in-reviews.liquid), so the count shown here
  // always matches what the sheet says once you click through to it.
  function initLiveReviewCount(root) {
    var textEl = root.querySelector('[data-petsuite-review-count]');
    if (!textEl) return;

    var params = ['pageIndex=1'];
    if (window.scs_reviews_section) {
      params.push('section=' + encodeURIComponent(window.scs_reviews_section));
    }

    fetch('https://scsbiz.wearevisum.com/api/v1/favorite-reviews?' + params.join('&'))
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (json) {
        var item = json && json.data && json.data[0];
        var total = item && Number(item.totalAll);
        if (!isFinite(total) || total <= 0) return;

        var formatted = Math.round(total).toLocaleString('en-US');
        textEl.textContent = textEl.textContent.replace(
          /\(\s*[\d,]+\s+Reviews?\s*\)/i,
          '(' + formatted + ' Reviews)'
        );
      })
      .catch(function (error) {
        console.warn('[SCS-PETSUITE-DOG] could not load live review count:', error);
      });
  }

  function getVariants(sectionId) {
    var key = 'scs_petsuite_variants_' + String(sectionId).replace(/-/g, '_');
    return window[key] || [];
  }

  function updatePriceDisplay(root, sectionId, variantId) {
    var variants = getVariants(sectionId);
    var variant = variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (!variant) return;

    // querySelectorAll, not querySelector: the price row and the ATC button label
    // both carry these hooks and both have to follow the selected variant.
    root.querySelectorAll('[data-petsuite-sale-price]').forEach(function (saleEl) {
      saleEl.textContent = formatMoney(variant.price);
    });
    root.querySelectorAll('[data-petsuite-compare-price]').forEach(function (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    });

    root.querySelectorAll('[data-petsuite-vehicle-card]').forEach(function (card) {
      if (String(card.dataset.variantId) !== String(variantId)) return;
      var vCompare = variant.compare_at_price || variant.price;
      var compareNode = card.querySelector('.SCS-PETSUITE-DOG__vehicle-compare');
      var saleNode = card.querySelector('.SCS-PETSUITE-DOG__vehicle-sale');
      var saveNode = card.querySelector('.SCS-PETSUITE-DOG__vehicle-save');
      if (saleNode) saleNode.textContent = formatMoney(variant.price);
      if (compareNode) {
        if (vCompare > variant.price) {
          compareNode.textContent = formatMoney(vCompare);
          compareNode.hidden = false;
        } else {
          compareNode.hidden = true;
        }
      }
      if (saveNode && vCompare > variant.price) {
        saveNode.textContent = saveNode.textContent.replace(/\$[\d,.]+/, formatMoney(vCompare - variant.price));
      }
    });
  }

  function initVehicleCards(root, sectionId) {
    var cards = root.querySelectorAll('[data-petsuite-vehicle-card]');
    if (!cards.length) return;

    var variantSelects = document.querySelector('variant-selects[data-section="' + sectionId + '"]');
    var formId = 'product-form-' + sectionId;
    var variantInput = document.querySelector('#' + formId + ' input[name="id"]');

    function selectVariant(variantId, optionValue) {
      if (variantInput) variantInput.value = variantId;

      if (variantSelects) {
        var select = variantSelects.querySelector('select[name^="options"]');
        if (select && optionValue) {
          select.value = optionValue;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      cards.forEach(function (card) {
        var isActive = String(card.dataset.variantId) === String(variantId);
        card.classList.toggle('is-active', isActive);
        card.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      updatePriceDisplay(root, sectionId, variantId);

      document.dispatchEvent(
        new CustomEvent('variant:change', {
          bubbles: true,
          detail: { variantId: variantId },
        })
      );
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        selectVariant(card.dataset.variantId, card.dataset.optionValue);
      });
    });

    document.addEventListener('variant:change', function (e) {
      if (!e.detail || !e.detail.variantId) return;
      updatePriceDisplay(root, sectionId, e.detail.variantId);
      cards.forEach(function (card) {
        var isActive = String(card.dataset.variantId) === String(e.detail.variantId);
        card.classList.toggle('is-active', isActive);
      });
    });

    if (variantInput) {
      variantInput.addEventListener('change', function () {
        updatePriceDisplay(root, sectionId, variantInput.value);
      });
    }
  }

  function initUpsellToggles(root) {
    root.querySelectorAll('[data-petsuite-upsell-toggle]').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var isOn = toggle.getAttribute('aria-checked') === 'true';
        toggle.setAttribute('aria-checked', isOn ? 'false' : 'true');
        toggle.classList.toggle('is-on', !isOn);
      });
    });
  }

  function getSelectedUpsells(root) {
    var selected = [];
    root.querySelectorAll('[data-petsuite-upsell-toggle].is-on').forEach(function (toggle) {
      var index = parseInt(toggle.dataset.upsellIndex, 10);
      var upsell = (window.scs_upsells || [])[index];
      if (upsell && upsell.variantId) {
        selected.push({
          id: upsell.variantId,
          quantity: 1,
          properties: { _widget_id: String(upsell.widgetId || '') },
        });
      }
    });
    return selected;
  }

  function initAddToCart(root, sectionId) {
    var productForm = root.querySelector('product-form[data-section="' + sectionId + '"]');
    if (!productForm) return;

    var form = productForm.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    // Capture-phase listener on the ancestor <product-form>, not the <form>
    // itself: product-form binds its own native submit handler directly to
    // the form (upgrades before this deferred script runs), so a bubble-phase
    // listener here would lose the race and let it add the main product a
    // second time. Capturing on the ancestor + stopPropagation() here keeps
    // the event from ever reaching that handler.
    productForm.addEventListener('submit', function (e) {
      var upsells = getSelectedUpsells(root);
      if (!upsells.length) return;

      e.preventDefault();
      e.stopPropagation();

      var variantInput = form.querySelector('input[name="id"]');
      var mainId = variantInput ? variantInput.value : null;
      if (!mainId) return;

      var items = [{ id: parseInt(mainId, 10), quantity: 1 }].concat(upsells);
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');

      fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function (err) {
          console.error('[PetSuite Dog]', err);
        })
        .finally(function () {
          if (submitBtn) submitBtn.removeAttribute('aria-busy');
        });
    }, true);
  }

  function initAccordions(root) {
    root.querySelectorAll('[data-petsuite-accordion]').forEach(function (accordion) {
      var header = accordion.querySelector('.SCS-PETSUITE-DOG__accordion-header');
      if (!header || header.dataset.petsuiteAccBound === 'true') return;
      header.dataset.petsuiteAccBound = 'true';

      header.addEventListener('click', function () {
        var willOpen = !accordion.classList.contains('is-open');
        accordion.classList.toggle('is-open', willOpen);
        header.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    root.querySelectorAll('[data-petsuite-faq-item]').forEach(function (item) {
      var question = item.querySelector('.scs-lsc-faq__question');
      if (!question || question.dataset.petsuiteFaqBound === 'true') return;
      question.dataset.petsuiteFaqBound = 'true';

      question.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var willOpen = !item.classList.contains('is-open');
        item.classList.toggle('is-open', willOpen);
        question.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
  }

  function initSection(root) {
    if (!root || root.dataset.petsuiteInitialized === 'true') return;
    root.dataset.petsuiteInitialized = 'true';

    var sectionId = root.dataset.sectionId;
    initFeatureRow(root);
    initThumbnailFeatures(root);
    initReviewsSheet();
    initInlineReviews(root, sectionId);
    initReviewsScroll(root, sectionId);
    initLiveReviewCount(root);
    initVehicleCards(root, sectionId);
    initUpsellToggles(root);
    initAddToCart(root, sectionId);
    initAccordions(root);
    initPhotoSwipeLightbox(root);

    function bootGallery() {
      initGalleryArrows(root);
    }

    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('slider-component').then(bootGallery).catch(bootGallery);
    } else {
      window.requestAnimationFrame(bootGallery);
    }
  }

  function initAll() {
    document.querySelectorAll('.SCS-PETSUITE-DOG').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.SCS-PETSUITE-DOG');
    if (root) initSection(root);
  });
})();
